import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import BrandMark from "../../components/BrandMark";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const u = await login(email, pwd);
      if (u?.must_change_password) nav("/admin/change-password");
      else nav("/admin");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:block bg-foreground text-background p-16">
        <div className="opacity-70"><BrandMark dark /></div>
        <h1 className="mt-12 text-5xl font-medium tracking-tight leading-tight">Аналитический <br/>контур</h1>
        <p className="mt-8 text-lg opacity-70 max-w-md">
          Управление сабмитами, шкалами и&nbsp;администраторами. Только для команды Hop.Agency.
        </p>
        <div className="mt-16 label-mono opacity-50">RESTRICTED</div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md space-y-6">
          <div>
            <Link to="/" className="hop-link text-sm">← на сайт</Link>
            <h2 className="text-3xl font-medium tracking-tight mt-3">Вход</h2>
          </div>
          <label className="block">
            <div className="label-mono mb-2">E-MAIL</div>
            <input data-testid="admin-email-input" className="field-input" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required />
          </label>
          <label className="block">
            <div className="label-mono mb-2">ПАРОЛЬ</div>
            <input data-testid="admin-password-input" className="field-input" value={pwd} onChange={(e) => setPwd(e.target.value)} type="password" required />
          </label>
          {error && <p className="text-destructive label-mono" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} className="btn-primary" data-testid="admin-login-submit">
            {busy ? "Вход…" : "Войти"}
          </button>
          <p className="text-xs text-foreground/50 pt-4 border-t border-black/10" data-testid="forgot-password-hint">
            Забыли пароль? Обратитесь к&nbsp;администратору Hop.Agency — он&nbsp;выпустит ссылку для&nbsp;сброса.
          </p>
        </form>
      </div>
    </div>
  );
}
